import { TranslateService } from 'ng2-translate';
import { ActivatedRoute } from '@angular/router';
import { FirebaseListObservable } from 'angularfire2/database-deprecated';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../_services/user.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { PostService } from '../_services/post.service';
import { MetaService } from 'ng2-meta';
import { ScrollService } from '../_services/scroll.service';


@Component({
  selector: 'app-hashtag-profile',
  templateUrl: './hashtag-profile.component.html',
  styleUrls: ['./hashtag-profile.component.css']

})
export class HashtagProfileComponent implements OnInit, OnDestroy {


  product: FirebaseListObservable<any[]>;
  name: string;
  uniqueName: string;
  currentUserId: string;
  activeId: any;
  visible: any;
  order = 'order';
  mobileQuery: any;
  private sub = new Subscription();
  private _mobileQueryListener: () => void;

  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService,
    private media: MediaMatcher,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    private scrollService: ScrollService,
    private metaService: MetaService,
    private postSw: PostService,
  ) {
    this.currentUserId = this.userService.getUid();
    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');

    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.sub = this.scrollService.isScroll.subscribe(a => {
      if (document.querySelector(".perfect-scrollbar").scrollTop > 620) {
        this.visible = true;

      }
      else {
        this.visible = false;

      }
    })


    this.sub = this.route.params.subscribe(params => {
      this.uniqueName = params['uniqueName'].toLowerCase();
      if (this.uniqueName === 'şikayetimvar') {
        this.metaService.setTitle('Müşterilerin' + ' ' + '#' + this.uniqueName + ' ' + 'Etiketli Paylaşımları | bigadvice.com');
        this.metaService.setTag('description', "Müşteri şikayetleri, markalarla ilgili her türlü görüş ve daha fazlası bigadvice'ta. ");
      }
      else if (this.uniqueName === 'bunuçoksevdim') {
        this.metaService.setTitle('Müşterilerin' + ' ' + '#' + this.uniqueName + ' ' + 'Etiketli Paylaşımları | bigadvice.com');
        this.metaService.setTag('description', "Müşterilerin memnun kaldığı ürün, hizmetler ve daha fazlası bigadvice'ta. ");

      }
      else if (this.uniqueName === 'markamaönerim') {
        this.metaService.setTitle('Müşterilerin' + ' ' + '#' + this.uniqueName + ' ' + 'Etiketli Paylaşımları | bigadvice.com');
        this.metaService.setTag('description', "Müşterilerin markalarına özel önerileri bigadvice'ta.");
      }
      else if (this.uniqueName === "benimtavsiyem") {
        this.metaService.setTitle('Müşterilerin' + ' ' + '#' + this.uniqueName + ' ' + 'Etiketli Paylaşımları | bigadvice.com');
        this.metaService.setTag('description', "Müşterilerin diğer kullanıcılara tavsiye ettiği ürün, hizmetler ve daha fazlası bigadvice'ta.");
      }

    });
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onTabChange($event) {


    this.activeId = $event.activeId;

    if (this.activeId === '1') {
      this.order = 'order';

    }
    else {
      this.order = 'valueOf_ModifyDate';


    }
    this.cd.markForCheck();
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/hashtag-profile/hashtag-profile.component.ts